import { render } from "./FirstPageLink.vue?vue&type=template&id=73c431a8"
import script from "./FirstPageLink.vue?vue&type=script&lang=js"
export * from "./FirstPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script